import React from 'react';
import { IconButton } from 'src/common/icon-button';

export const ColorSelectionControlButton = ({
  disabled = false,
  onClick,
}: {
  disabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <IconButton disabled={disabled} classes='w-8 h-8' onClick={onClick}>
      <svg
        className='transform-gpu'
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M15.0141 19.1712C14.8218 18.6752 14.4705 18.2645 14.0206 18.0096C13.5706 17.7546 13.0499 17.6713 12.5477 17.7738C12.0455 17.8764 11.593 18.1584 11.2676 18.5716C10.9423 18.9848 10.7645 19.5035 10.7645 20.0388C10.7645 20.2758 10.718 20.5103 10.6278 20.7277C10.5377 20.9451 10.4058 21.1408 10.2404 21.3027C10.0749 21.4646 9.87946 21.5892 9.6661 21.6688C9.45274 21.7484 9.22603 21.7814 9 21.7656C9.36353 22.4262 9.92537 22.9429 10.5983 23.2353C11.2713 23.5277 12.0176 23.5795 12.7216 23.3826C13.4256 23.1858 14.0477 22.7514 14.4915 22.1467C14.9353 21.5421 15.1759 20.8011 15.1759 20.0388C15.1759 19.7319 15.1185 19.4389 15.0141 19.1712ZM15.0141 19.1712C15.8883 18.8596 16.7244 18.4414 17.505 17.9252C18.8993 17.0036 20.0919 15.7856 21.0069 14.3502L23.8566 9.87834C23.9658 9.70802 24.015 9.50333 23.996 9.29924C23.9769 9.09515 23.8907 8.9043 23.7521 8.7593C23.6135 8.61429 23.4311 8.52413 23.236 8.50419C23.0409 8.48426 22.8453 8.5358 22.6825 8.65001L18.4079 11.632C17.0356 12.5889 15.8711 13.8363 14.9898 15.2947C14.4955 16.113 14.0952 16.9895 13.7973 17.906'
          stroke='currentCOlor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconButton>
  );
};
